import _ from 'lodash'
import React, {useEffect, useState, useRef, useMemo} from 'react'
import PageApp from '../../../Page';
import ModalFiniquitos from './Finiquitos';
import { HomeOutlined, UnorderedListOutlined, ExclamationCircleFilled, InfoCircleOutlined, EyeOutlined, UploadOutlined } from '@ant-design/icons';
import {Row, Col, Table, Empty, Modal, Form, Divider, Button, message, Space, Skeleton, Tooltip, Select, Tag, Input, Checkbox} from 'antd';
import {getAll} from '../../../../apis/BajaEmpleadoApi';
import ModalCartaUploadFiles from './CartaUpload';
import ModalComprobanteUploadFiles from './ComprobanteUpload';
const {Option} = Select;
const { confirm } = Modal;

const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Nomina</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Liquidacion</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Finiquitos</span>
      </>
    ),
}];

const Index = () => {
    const [ form ] = Form.useForm()
    const [items, setItems] = useState([]);
    const [filteredItems, setFilteredItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    
    // Estados para el modal de detalle
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    
    const [selectedMovimiento, setSelectedMovimiento] = React.useState(null);
    const [openUploadCartaFile, setOpenUploadCartaFile] = useState(false);
    const [openUploadComprobanteFile, setOpenUploadComprobanteFile] = useState(false);

    // Estados para los filtros
    const [filters, setFilters] = useState({
      numero: '',
      nombre: '',
      area: [],
      regimenPatron: [],
      tipoPeriodo: [],
      estatus: []
    });

    const areaOptions = useMemo(() => {
      const unique = [...new Set(items.map(i => i.area).filter(Boolean))];
      return unique.sort().map(v => ({ label: v, value: v }));
    }, [items]);

    const regimenPatronOptions = useMemo(() => {
      const unique = [...new Set(items.map(i => i.regimen_patron).filter(Boolean))];
      return unique.sort().map(v => ({ label: v, value: v }));
    }, [items]);

    const tipoPeriodoOptions = useMemo(() => {
      const unique = [...new Set(items.map(i => i.tipo_periodo).filter(Boolean))];
      return unique.sort().map(v => ({ label: v, value: v }));
    }, [items]);
    
    // useEffect para cargar datos iniciales con estatus 1 (PENDIENTE)
    useEffect(() => {
      const loadInitialData = async () => {
        setLoading(true);
        try {
          const response = await getAll(); // Estatus 1 = PENDIENTE
          
          if (response.ok) {
            // Agregar key única para cada registro
            const itemsWithKey = response.payload.map(item => ({
              ...item,
              key: item.id
            }));
            setItems(itemsWithKey);
            setFilteredItems(itemsWithKey);
          } else {
            message.error('Error al obtener los datos pendientes');
            setItems([]);
            setFilteredItems([]);
          }
        } catch (error) {
          message.error('Error en la consulta inicial');
          setItems([]);
          setFilteredItems([]);
        } finally {
          setLoading(false);
        }
      };

      loadInitialData();
    }, []);

    // Función para abrir el modal con detalles del registro
    const handleRowClick = (record) => {
      setSelectedRecord(record);
      setModalVisible(true);
    };

    // Función para cerrar el modal
    const handleModalClose = () => {
      setModalVisible(false);
      setSelectedRecord(null);
    };

    const handleUpdateRecord = async ({id, status}) => {
      var item = items.find(x=>x.id == id);
      item.status = status;
      setItems(items);
    };

    // Función para aplicar filtros
    const applyFilters = () => {
      let filtered = items;

      // Filtro por número
      if (filters.numero) {
        filtered = filtered.filter(item => 
          item.nomina_employee_number?.toString().includes(filters.numero)
        );
      }

      // Filtro por nombre
      if (filters.nombre) {
        filtered = filtered.filter(item => 
          item.empleado?.toLowerCase().includes(filters.nombre.toLowerCase())
        );
      }

      // Filtro por área
      if (filters.area.length > 0) {
        filtered = filtered.filter(item => 
          filters.area.includes(item.area)
        );
      }

      // Filtro por régimen patrón
      if (filters.regimenPatron.length > 0) {
        filtered = filtered.filter(item => 
          filters.regimenPatron.includes(item.regimen_patron)
        );
      }

      // Filtro por tipo período
      if (filters.tipoPeriodo.length > 0) {
        filtered = filtered.filter(item => 
          filters.tipoPeriodo.includes(item.tipo_periodo)
        );
      }

      // Filtro por estatus
      if (filters.estatus.length > 0) {
        filtered = filtered.filter(item => 
          filters.estatus.includes(item.status)
        );
      }

      setFilteredItems(filtered);
    };

    // useEffect para aplicar filtros cuando cambien
    useEffect(() => {
      applyFilters();
    }, [filters, items]);

    const handleFilterChange = (field, value) => {
      if (field === 'numero') {
        const match = value ? items.find(i => i.nomina_employee_number?.toString() === value) : null;
        setFilters(prev => ({
          ...prev,
          numero: value,
          nombre: match ? (match.empleado || '') : ''
        }));
      } else if (field === 'nombre') {
        const matches = value ? items.filter(i => i.empleado?.toLowerCase().includes(value.toLowerCase())) : [];
        const exact = matches.length === 1 ? matches[0] : null;
        setFilters(prev => ({
          ...prev,
          nombre: value,
          numero: exact ? String(exact.nomina_employee_number) : (value ? prev.numero : '')
        }));
      } else {
        setFilters(prev => ({
          ...prev,
          [field]: value
        }));
      }
    };

    const handleAgregar = () => {
      // Lógica para agregar nuevo registro
      message.info('Función de agregar en desarrollo');
    };

    const handleImprimirCartaFiniquito = () => {
      if (selectedRowKeys.length === 0) {
        message.warning('Seleccione al menos un registro para imprimir');
        return;
      }
      // Lógica para imprimir carta finiquito
      message.info(`Imprimiendo carta finiquito para ${selectedRowKeys.length} registro(s)`);
    };

    const handleCalcularVarios = () => {
      if (selectedRowKeys.length === 0) {
        message.warning('Seleccione al menos un registro para calcular');
        return;
      }
      // Lógica para calcular varios
      message.info(`Calculando ${selectedRowKeys.length} registro(s)`);
    };

    const handleSubirFirmado = (record) => {
      setSelectedMovimiento(record);
      setOpenUploadCartaFile(true);
      // Lógica para subir documento firmado
      // message.info(`Subiendo documento firmado para empleado: ${record.empleado_nombre}`);
    };

    const handleSubirPagado = (record) => {
      setSelectedMovimiento(record);
      setOpenUploadComprobanteFile(true);
      // Lógica para subir comprobante de pago
      // message.info(`Subiendo comprobante de pago para empleado: ${record.empleado_nombre}`);
    };

    const refreshData = () => {
    };

    const columns = [
      {
        title: 'Seleccionar',
        key: 'select',
        width: 80,
        render: (text, record) => (
          <Checkbox
            checked={selectedRowKeys.includes(record.key)}
            onChange={(e) => {
              e.stopPropagation(); // Evitar que se active el click de la fila
              if (e.target.checked) {
                setSelectedRowKeys([...selectedRowKeys, record.key]);
              } else {
                setSelectedRowKeys(selectedRowKeys.filter(key => key !== record.key));
              }
            }}
          />
        ),
      },
      {
        title: 'No. Empleado',
        dataIndex: 'nomina_employee_number',
        key: 'nomina_employee_number',
        width: 120,
      },
      {
        title: 'Nombre Empleado',
        dataIndex: 'empleado',
        key: 'empleado',
        width: 200,
      },
      {
        title: 'Fecha de Ingreso',
        dataIndex: 'nomina_entry_date',
        key: 'nomina_entry_date',
        width: 130,
        render: (item) => {
          const formattedDate = item ? new Date(item).toLocaleDateString() : '';
          return formattedDate;
        }
      },
      {
        title: 'Fecha de Baja',
        dataIndex: 'fecha_baja',
        key: 'fecha_baja',
        width: 130,
        render: (item, object) => {
          const formattedDate = item ? new Date(item).toLocaleDateString() : '';
          return <Space>
            {formattedDate}
            <Tooltip title={'Información adicional'}>
              <InfoCircleOutlined />
            </Tooltip>
          </Space>
        }
      },
      {
        title: 'Estatus',
        dataIndex: 'status',
        key: 'status',
        width: 120,
        render: (status, record) => {
          if (status === 1) // PENDIENTE
            return <Tag color={'#faad14'} key={'pendiente'}>
              {'Pendiente'}
            </Tag>
          
          if (status === 2) // PROCESO
            return <Tag color={'#2db7f5'} key={'proceso'}>
              {'Proceso'}
            </Tag>
          
          if (status === 3) // CALCULADO
            return <Tag color={'#722ed1'} key={'calculado'}>
              {'Calculado'}
            </Tag>
          
          if (status === 4) // AFECTADO
            return <Tag color={'#13c2c2'} key={'afectado'}>
              {'Afectado'}
            </Tag>
          
          if (status === 5) // PAGADO
            return <Tag color={'#52c41a'} key={'pagado'}>
              {'Pagado'}
            </Tag>
          
          if (status === 6) // TIMBRADO
            return <Tag color={'#eb2f96'} key={'timbrado'}>
              {'Timbrado'}
            </Tag>
          
          if (status === 7) // CANCELADO
            return <Tag color={'#8c8c8c'} key={'cancelado'}>
              {'Cancelado'}
            </Tag>
          
          if (status === 0) // ERROR
            return <>
              <Tag color={'#f50'} key={'error'}>
                {'Error'}
              </Tag>
              {record.error && (
                <Tooltip title={record.error}>
                  <InfoCircleOutlined />
                </Tooltip>
              )}
            </>
          
          return <Tag color={'default'} key={'unknown'}>
            {record.status_text || 'Desconocido'}
          </Tag>
        }
      },
      {
        title: 'Firmado',
        key: 'firmado',
        width: 100,
        render: (text, record) => (
          <Button
            type="primary"
            size="small"
            icon={<UploadOutlined />}
            onClick={(e) => {
              e.stopPropagation(); // Evitar que se active el click de la fila
              handleSubirFirmado(record);
            }}
          >
            Subir
          </Button>
        ),
      },
      {
        title: 'Pagado',
        key: 'pagado',
        width: 100,
        render: (text, record) => (
          <Button
            type="primary"
            size="small"
            icon={<UploadOutlined />}
            onClick={(e) => {
              e.stopPropagation(); // Evitar que se active el click de la fila
              handleSubirPagado(record);
            }}
          >
            Subir
          </Button>
        ),
      },
      {
        title: 'Acciones',
        key: 'acciones',
        width: 100,
        render: (text, record) => (
          <Button
            type="link"
            icon={<EyeOutlined />}
            onClick={(e) => {
              e.stopPropagation(); // Evitar doble activación
              handleRowClick(record);
            }}
          >
            Ver Detalle
          </Button>
        ),
      },
    ];

    const handleSeleccionarTodos = (checked) => {
      if (checked) {
        const allKeys = filteredItems.map(item => item.key);
        setSelectedRowKeys(allKeys);
      } else {
        setSelectedRowKeys([]);
      }
    };

    const statusOptions = [
      { label: 'Pendiente', value: 1 },
      { label: 'Proceso', value: 2 },
      { label: 'Calculado', value: 3 },
      { label: 'Afectado', value: 4 },
      { label: 'Pagado', value: 5 },
      { label: 'Timbrado', value: 6 },
      { label: 'Cancelado', value: 0 },
    ];

    return <PageApp 
      routes={routes}
      title={'Empleados con sus bajas'}>
        
        {/* Fila superior: Número + Nombre */}
        <Row gutter={16} style={{ marginBottom: 16 }}>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item label="Número">
              <Input
                placeholder="Número"
                value={filters.numero}
                onChange={(e) => handleFilterChange('numero', e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item label="Nombre">
              <Input
                placeholder="Nombre"
                value={filters.nombre}
                onChange={(e) => handleFilterChange('nombre', e.target.value)}
              />
            </Form.Item>
          </Col>
        </Row>

        {/* Fila inferior: Área, Reg Patrón, Tipo Período, Estatus */}
        <Row gutter={16} style={{ marginBottom: 16 }}>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item label="Área">
              <Select
                mode="multiple"
                allowClear
                style={{ width: '100%' }}
                placeholder="Seleccione área(s)"
                value={filters.area}
                onChange={(value) => handleFilterChange('area', value)}
                showSearch
                maxTagCount="responsive"
                options={areaOptions}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item label="Reg Patrón">
              <Select
                mode="multiple"
                allowClear
                style={{ width: '100%' }}
                placeholder="Seleccione régimen"
                value={filters.regimenPatron}
                onChange={(value) => handleFilterChange('regimenPatron', value)}
                showSearch
                maxTagCount="responsive"
                options={regimenPatronOptions}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item label="Tipo Período">
              <Select
                mode="multiple"
                allowClear
                style={{ width: '100%' }}
                placeholder="Seleccione tipo(s)"
                value={filters.tipoPeriodo}
                onChange={(value) => handleFilterChange('tipoPeriodo', value)}
                showSearch
                maxTagCount="responsive"
                options={tipoPeriodoOptions}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item label="Estatus">
              <Select
                mode="multiple"
                allowClear
                style={{ width: '100%' }}
                placeholder="Seleccione uno o más estatus"
                value={filters.estatus}
                onChange={(value) => handleFilterChange('estatus', value)}
                showSearch={false}
                maxTagCount="responsive"
              >
                {statusOptions.map(option => (
                  <Option key={option.value} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        {/* Botones de acción */}
        <Row gutter={16} style={{ marginBottom: 16 }}>
          <Col>
            <Button onClick={handleAgregar}>
              Agregar
            </Button>
          </Col>
          <Col>
            <Button onClick={handleImprimirCartaFiniquito}>
              Imprimir Carta Finiquito
            </Button>
          </Col>
          <Col>
            <Button onClick={handleCalcularVarios}>
              Calcular Varios
            </Button>
          </Col>
          <Col>
            <Checkbox
              checked={selectedRowKeys.length === filteredItems.length && filteredItems.length > 0}
              indeterminate={selectedRowKeys.length > 0 && selectedRowKeys.length < filteredItems.length}
              onChange={(e) => handleSeleccionarTodos(e.target.checked)}
            >
              Seleccionar Todos
            </Checkbox>
          </Col>
        </Row>

        {/* Tabla de datos */}
        {
          loading ?
          <Skeleton loading={loading}/>:
          <>
            {
              filteredItems.length === 0 ? <Empty />:
              <Table 
                dataSource={filteredItems} 
                columns={columns}
                scroll={{ x: 1400 }}
                onRow={(record) => {
                  return {
                    onClick: () => handleRowClick(record), // Hacer click en cualquier parte de la fila
                    style: { cursor: 'pointer' }
                  };
                }}
                pagination={{
                  pageSize: 10,
                  showSizeChanger: true,
                  showQuickJumper: true,
                  showTotal: (total, range) => 
                    `${range[0]}-${range[1]} de ${total} elementos`
                }}
              />
            }
          </>
        }

        {/* Modal de detalle - componente separado */}
        <ModalFiniquitos
          visible={modalVisible}
          onClose={handleModalClose}
          recordId={selectedRecord?.id || selectedRecord?.odoo_id}
          recordData={selectedRecord}
          updateRecordData={handleUpdateRecord}
        />

        {
          openUploadCartaFile && selectedMovimiento && (
          <ModalCartaUploadFiles
            title={'Subir carta firmada'}
            open={openUploadCartaFile}
            finish={(refresh) => {
              setOpenUploadCartaFile(false);
              if (refresh) refreshData();
            }}
            odoo_movimiento={selectedMovimiento}
          />
        )}

        {
          openUploadComprobanteFile && selectedMovimiento && (
          <ModalComprobanteUploadFiles
            title={'Subir comprobante de pago'}
            open={openUploadComprobanteFile}
            finish={(refresh) => {
              setOpenUploadComprobanteFile(false);
              if (refresh) refreshData();
            }}
            odoo_movimiento={selectedMovimiento}
          />
        )}
    </PageApp>
}   

export default Index;